import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CABINET_PATHS } from '@nebalkon-workspace/cabinet-core';
import { StaffKpiCardComponent } from '../home/staff-kpi-card.component';
import { bindStaffPageTitleCount } from '../admin/staff-page-title-count.util';
import {
  STAFF_LEAD_SECTION_NAV,
  staffLeadStatsValue,
} from './staff-lead-section.util';
import { StaffLeadsStatsService } from './staff-leads-stats.service';

@Component({
  selector: 'lib-staff-leads-hub',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, StaffKpiCardComponent],
  templateUrl: './staff-leads-hub.component.html',
  styleUrl: './staff-leads-hub.component.scss',
})
export class StaffLeadsHubComponent implements OnInit {
  readonly embeddedInCabinetPage = input(false);

  readonly #cabinetPaths = inject(CABINET_PATHS);
  readonly #router = inject(Router);
  readonly #statsService = inject(StaffLeadsStatsService);

  protected readonly sections = STAFF_LEAD_SECTION_NAV;
  protected readonly stats = this.#statsService.stats;
  protected readonly loading = this.#statsService.loading;
  protected readonly accessDenied = this.#statsService.accessDenied;
  protected readonly error = this.#statsService.error;

  protected readonly displayCount = computed(() => this.#statsService.newTotal());

  constructor() {
    bindStaffPageTitleCount(this.embeddedInCabinetPage, this.displayCount);
  }

  public ngOnInit(): void {
    this.#statsService.ensureLoaded();
  }

  protected sectionValue(section: (typeof STAFF_LEAD_SECTION_NAV)[number]['id']): number {
    return staffLeadStatsValue(this.stats(), section);
  }

  protected openSection(section: (typeof STAFF_LEAD_SECTION_NAV)[number]['id']): void {
    void this.#router.navigate([this.#cabinetPaths.staff, 'leads', section]);
  }

  protected refresh(): void {
    this.#statsService.refresh();
  }
}
